// URL pública da waba: exemplos de cURL e chamadas por api-key (console de ligações).
export const WABA_BASE = "https://waba.revendai.com";
// Chamadas do painel (cookie de sessão): mesma origem, o Traefik repassa
// valquiria.revendai.com/waba-api/* pra waba. O cookie é só deste host (não
// vale mais pra *.revendai.com), então não pode ir direto em waba.revendai.com.
const PANEL_BASE = "/waba-api";

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${PANEL_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...init.headers },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw Object.assign(new Error(body.detail ?? res.statusText), { status: res.status, payload: body });
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export const wabaApi = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "POST", body: data ? JSON.stringify(data) : undefined }),
  patch: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "PATCH", body: data ? JSON.stringify(data) : undefined }),
  put: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "PUT", body: data ? JSON.stringify(data) : undefined }),
  delete: <T>(path: string) => request<T>(path, { method: "DELETE" }),
  // Baixa um arquivo (CSV/blob). fetch+blob: <a download> simples não honra o filename.
  download: async (path: string, filename: string) => {
    const res = await fetch(`${PANEL_BASE}${path}`, { credentials: "include" });
    if (!res.ok) throw new Error(res.statusText);
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  },
};
